console.log('hello world');

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import Tooltip from '@ryangjchandler/alpine-tooltip';
import { parseISO, intervalToDuration } from 'date-fns';
import videojs from 'video.js';
import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs, Keyboard } from 'swiper/modules';
import 'swiper/css';
// import 'swiper/css/pagination';
import 'video.js/dist/video-js.min.css';
import 'videojs-markers-plugin';
import 'videojs-markers-plugin/dist/videojs.markers.plugin.css';
import 'videojs-youtube';

import { easepick } from '@easepick/core';
import { RangePlugin } from '@easepick/range-plugin';
import { AmpPlugin } from '@easepick/amp-plugin';

import Parallax from 'parallax-js';

// Swiper.use([Navigation, Pagination, Thumbs]);

const body = document.body;
const scrollUp = 'scroll-up';
const scrollDown = 'scroll-down';
let lastScroll = 0;

const videos = document.querySelectorAll('.video-js');

window.Alpine = Alpine;

Alpine.plugin(focus);

Alpine.store('hamburger', {
	on: false,

	toggle() {
		this.on = !this.on;
	}
});

Alpine.store('search', {
	on: false,

	toggle() {
		this.on = !this.on;
	}
});

Alpine.store('userModal', {
	state: (location.hash === '#lost-password' || location.hash === '#press-login' || location.hash === '#press-registration' || location.hash === '#press-lost-password') ? location.hash : false,
});

Alpine.data('timer', (expiry) => ({
	expiry: parseISO(expiry),
	remaining: null,
	init() {
		this.setRemaining();
		setInterval(() => {
			this.setRemaining();
		}, 1000);
	},
	setRemaining() {
		this.remaining = intervalToDuration({
			start: new Date(),
			end: this.expiry
		});
	},
}));

Alpine.data('news', (initAgeGroup) => ({
	current_page: 0,
	ageGroup: initAgeGroup,
	newsData: {
		items: [],
		pagination: {}
	},
	async getNews(page) {
		let response = await fetch(`/api/news/more?page=${page}&lang=${lang}&ageGroup=${this.ageGroup}`);
		let data = await response.json();

		return data;
	},
	moreNews() {
		if (this.current_page !== this.newsData.pagination.last_page) {
			this.current_page++;
			this.getNews(this.current_page)
				.then(data => {
					this.newsData.pagination = data.pagination;
					this.newsData.items = [...this.newsData.items, ...data.items];
				});
		}
	},
}));

Alpine.data('gallery', () => ({
	current_page: 0,
	galleryData: {
		items: [],
		pagination: {}
	},
	async getGallery(page) {
		let response = await fetch(`/api/galleries/more?page=${page}&lang=${lang}`);
		let data = await response.json();

		return data;
	},
	moreGallery() {
		if (this.current_page !== this.galleryData.pagination.last_page) {
			this.current_page++;
			this.getGallery(this.current_page)
				.then(data => {
					this.galleryData.pagination = data.pagination;
					this.galleryData.items = [...this.galleryData.items, ...data.items];
				});
		}
	},
}));

Alpine.data('videos', () => ({
	current_page: 0,
	videosData: {
		items: [],
		pagination: {}
	},
	async getVideos(page, filters) {
		let url = `/api/videos/more?page=${page}&lang=${lang}`;
		if (filters) {
			url += `&filters=${filters}`;
		}
		let response = await fetch(url);
		let data = await response.json();

		return data;
	},
	moreVideos(filters = null) {
		if (this.current_page !== this.videosData.pagination.last_page) {
			this.current_page++;
			this.getVideos(this.current_page, filters)
				.then(data => {
					this.videosData.pagination = data.pagination;
					this.videosData.items = [...this.videosData.items, ...data.items];
				});
		}
	},
}));

Alpine.data('drowdown', () => ({
	open: false,
	toggle() {
		this.open = !this.open;
	},
	close() {
		this.open = false;
	}
}));

Alpine.data('drowdownSearch', (type, value = null) => ({
	open: false,
	selected: value,
	fetchStatus: 'loading',
	data: [],
	type,
	async fetchData() {
		let apiUrl = null;

		switch (type) {
			case 'age_group':
				apiUrl = `api/ageGroups?name=${this.selected}&per_page=*&lang=${lang}`;
				break;

			case 'player':
				apiUrl = `api/players?name=${this.selected}&fields=id,fullName&per_page=*&lang=${lang}`;
				break;

			case 'club':
				apiUrl = `api/clubs?name=${this.selected}&per_page=*&lang=${lang}`;
				break;
		}

		console.log(apiUrl);
		let response = await fetch(apiUrl);
		let data = await response.json();
		console.log(data);

		this.data = data.items;
	},
	init() {
		console.log(type);
		console.log(this.selected);
		if (value) {
			this.fetchData();
		}
		this.$watch('selected', () => {
			console.log(this.selected, this.selected.length);
			if (this.selected.length > 2) {
				this.fetchData();
			}
			else {
				this.data = [];
			}
		});
	},
	toggle() {
		this.open = !this.open;
	},
	close() {
		this.open = false;
	}
}));

Alpine.data('lightbox', () => ({
	lightboxOpen: false,
	swiperLightboxThumbnail: null,
	swiperLightbox: null,
	synchronized: false,
	init() {
		this.swiperLightboxThumbnail = new Swiper(this.$refs.sliderLightboxThumbnail, {
			modules: [Navigation],
			initialSlide: 0,
			slidesPerView: 3.5,
			// centeredSlides: true,
			// freeMode: true,
			watchSlidesProgress: true,
			cssMode: true,
			navigation: {
				nextEl: '.swiper-lightbox-thumbnail-next',
				prevEl: '.swiper-lightbox-thumbnail-prev',
			},
			breakpoints: {
				1024: {
					slidesPerView: 6.5,
				}
			}
		});

		this.swiperLightbox = new Swiper(this.$refs.sliderLightbox, {
			modules: [Navigation, Pagination, Thumbs, Keyboard],
			initialSlide: 0,
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 20,
			cssMode: true,
			navigation: {
				nextEl: '.swiper-lightbox-next',
				prevEl: '.swiper-lightbox-prev',
			},
			pagination: {
				el: '.modal-lightbox .swiper-pagination',
				type: 'fraction',
				formatFractionTotal: (number) => {
					return `${number} ` + (lang == "hu" ? "kép" : "photos");
				}
			},
			thumbs: {
				swiper: this.swiperLightboxThumbnail,
			},
			keyboard: {
				enabled: true,
			}
		});

		window.addEventListener('slider.magazine.slidechange', (e) => {
			this.synchronized = true;
			// console.log('slider.magazine.slidechange');
			this.swiperLightbox.slideTo(e.detail, 0, false);
		});
	},
	lightboxToggle(index) {
		this.lightboxOpen = !this.lightboxOpen;
		body.classList.toggle('overflow-hidden');

		if (index) {
			// console.log('index');
			setTimeout(() => {
				this.swiperLightbox.slideTo(index, 0, false);
			}, 500);
		} else if (swiperMagazine?.activeIndex) {
			// console.log('synchronized');
		}
		else if (swiperMagazine?.activeIndex) {
			// console.log('swiperMagazine.activeIndex', swiperMagazine?.activeIndex);
			setTimeout(() => {
				this.swiperLightbox.slideTo(swiperMagazine.activeIndex, 0, false);
			}, 500);
		}
		else {
			// console.log('wtf');
			setTimeout(() => {
				this.swiperLightbox.slideTo(0, 0, false);
			}, 500);
		}

		document.documentElement.requestFullscreen();
		this.swiperLightbox.update();
	},
	lightboxClose() {
		this.lightboxOpen = false;
		body.classList.remove('overflow-hidden');
		if (document.fullscreenElement) {
			document.exitFullscreen();
		}
		if (swiperMagazine?.activeIndex) {
			setTimeout(() => {
				swiperMagazine.slideTo(this.swiperLightbox.activeIndex);
			}, 500);
		}
	}
}));

Alpine.data('fixtures', () => ({
	fixtures,
	showAll: false,
	selectedCompetitions: [],
	filterCompetition() {
		if (this.selectedCompetitions.length) {
			const filtered = Object.fromEntries(
				Object.entries(fixtures)
					.map(
						([k, v]) => [
							k,
							{
								...v,
								matches: v.matches.filter(m => this.selectedCompetitions.includes(m.competition.id.toString()))
							}
						]
					)
					.filter(
						([k, v]) => v.matches.length > 0
					)
			);

			this.fixtures = filtered;
		}
		else {
			this.fixtures = fixtures;
		}
	}
}));

Alpine.data('playerStats', (seasonId) => ({
	seasonCompetitions,
	selectedSeason: seasonId,
	filteredCompetition: [],
	selectedCompetition: null,
	playerStatsData: {},
	async getPlayerStats(seasonId, competitionId) {
		let response = await fetch(`/api/player/${playerId}/${seasonId}/${competitionId}`);
		let data = await response.json();

		this.playerStatsData = data;
	},
	init() {
		this.filteredCompetition = this.seasonCompetitions.find(el => el.seasonId === parseInt(this.selectedSeason)).competitions;
		this.selectedCompetition = this.filteredCompetition[0].id;
		console.log(this.seasonCompetitions, this.selectedSeason, this.filteredCompetition, this.selectedCompetition);
		console.log(this.playerStatsData);
		this.getPlayerStats(this.selectedSeason, this.selectedCompetition);
	},
	changeSeason() {
		this.filteredCompetition = this.seasonCompetitions.find(el => el.seasonId === parseInt(this.selectedSeason)).competitions;
		this.selectedCompetition = this.filteredCompetition[0].id;
		console.log(this.selectedSeason, this.selectedCompetition);
		this.getPlayerStats(this.selectedSeason, this.selectedCompetition);
	},
	changeCompetition() {
		console.log(this.selectedSeason, parseInt(this.selectedCompetition));
		this.getPlayerStats(this.selectedSeason, this.selectedCompetition);
	}
}));

Alpine.data('datepicker', (range = false) => ({
	datepicker: null,
	init() {
		console.log(range);
		if (range) {
			this.daterangepicker = new easepick.create({
				element: this.$refs.datepickerInput,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
					'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.0/dist/index.css',
					'/assets/css/easepick.css',
				],
				zIndex: 10,
				lang: lang,
				RangePlugin: {
					tooltip: false
				},
				plugins: [RangePlugin],
			});
		}
		else {
			this.datepicker = new easepick.create({
				element: this.$refs.datepickerInput,
				css: [
					'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
					'https://cdn.jsdelivr.net/npm/@easepick/amp-plugin@1.2.0/dist/index.css',
					'/assets/css/easepick.css',
				],
				zIndex: 10,
				lang: lang,
				AmpPlugin: {
					dropdown: {
						months: true,
						years: true,
						minYear: 1901
					}
				},
				plugins: [AmpPlugin]
			});
		}
	}
}));

Alpine.data('video', () => ({
	init() {
		console.log('video');
	}
}));

Alpine.data('online', () => ({
	match,
	squads,
	statistics,
	init() {
		console.log(`${this.match.id} online`);
		if (this.match.isOnline) {
			setInterval(async () => {
				let response = await fetch(`/api/matches/${this.match.id}/onlineData`);
				let data = await response.json();

				this.match = data.match;
				this.squads = data.squads;
				this.statistics = data.statistics;
			}, 60000);
		}
	},
	currentMinute() {
		if (this.match.clockTime.overMinute) {
			return this.match.clockTime.minute + '+' + (this.match.clockTime.overMinute+1) + "'";
		}
		return this.match.clockTime.minute+1 + "'";
	}
}));

Alpine.data('timeline', () => ({
	timeline,
	width: ((timeline.minutes / timeline.totalMinutes) * 100),
	init() {
		console.log(`${this.match.id} timeline`);
		if (this.match.isOnline) {
			setInterval(async () => {
				let response = await fetch(`/api/matches/${this.match.id}/timeline`);
				let data = await response.json();

				this.timeline = data.timeline;
				this.width = ((data.timeline.minutes / data.timeline.totalMinutes) * 100);
			}, 60000);
		}
	}
}));

Alpine.data('events', () => ({
	events,
	init() {
		console.log(`${this.match.id} events`);
		if (this.match.isOnline) {
			setInterval(async () => {
				let response = await fetch(`/api/matches/${this.match.id}/onlineEvents`);
				let data = await response.json();

				this.events = data.events;
			}, 60000);
		}
	},
	async addHighFive(event) {
		let response = await fetch(`/api/matches/${this.match.id}/highFives/${event.id}`, { method: 'POST'});
		let data = await response.json();

		return data;
	},
	highFive(event) {
		this.addHighFive(event).then(data => {
			event.highFives = data.highFives;
		})
	}
}));

Alpine.data('statistics', () => ({
	seasons: [],
	players: [],
	competitions: [],
	selectedSeason: null,
	selectedPlayer: null,
	selectedCompetitions: [],
	reportForm: 'detailed',
	queryInProgress: false,
	detailedStats: [],
	aggregatedStats: {},

	init() {
		this.selectedSeason = null;
		this.fetchSeasons();
		this.fetchPlayers();
	},

	async fetchSeasons() {
		this.queryInProgress = true;

		let response = await fetch(`/api/statistics/seasons`);
		let data = await response.json();

		this.seasons.push({ id: null, name: 'Összes szezon' });
		this.seasons = this.seasons.concat(data);
		this.selectedSeason = null;
		this.competitions = [];
		this.selectedCompetitions = [];

		this.queryInProgress = false;
	},

	async fetchPlayers() {
		this.queryInProgress = true;

		this.players = [];
		this.players.push({
			"player_id": null,
			"mlsz_id": null,
			"full_name": 'Összes játékos',
			"short_name": null,
			"date_of_birth": null,
		});

		let response = await fetch(`/api/statistics/players?season_id=${this.selectedSeason}`);
		let data = await response.json();

		this.players = this.players.concat(data);
		this.selectedPlayer = null;
		this.competitions = [];
		this.selectedCompetitions = [];

		this.queryInProgress = false;

		this.fetchCompetitions();
	},

	async fetchCompetitions() {
		if (!this.selectedSeason && !this.selectedPlayer) return;

		this.queryInProgress = true;

		let url = `/api/statistics/competitions?season_id=${this.selectedSeason}`;
		if (this.selectedPlayer) {
			url += `&player_id=${this.selectedPlayer}`;
		}

		let response = await fetch(url);
		let data = await response.json();
		this.competitions = data;

		this.queryInProgress = false;
	},

	maxMinutes(seasons) {
		return Object.values(seasons).reduce((a, b) => a + b, 0);
	},

	handleDownload(event) {
		if (this.isButtonDisabled) {
			event.preventDefault();
		} else {
			window.open(this.downloadUrl, '_blank');
		}
	},

	get isButtonDisabled() {
		return (!this.selectedSeason && !this.selectedPlayer) || this.queryInProgress;
	},

	get downloadUrl() {
		let url = `/statisztikak/letoltes?season_id=${this.selectedSeason}&player_id=${this.selectedPlayer}&report_form=${this.reportForm}`;
		if (this.selectedCompetitions.length) {
			url += `&competition_id=${this.selectedCompetitions.join(',')}`;
		} else {
			url += `&competition_id=${this.competitions.map(obj => obj.id).join(',')}`;
		}

		return url;
	},

	async getStats() {
		this.queryInProgress = true;

		this.detailedStats = [];
		this.aggregatedStats = {};

		let url = `/api/statistics?season_id=${this.selectedSeason}&player_id=${this.selectedPlayer}&report_form=${this.reportForm}`;
		if (this.selectedCompetitions.length) {
			url += `&competition_id=${this.selectedCompetitions.join(',')}`;
		} else {
			url += `&competition_id=${this.competitions.map(obj => obj.id).join(',')}`;
		}

		let response = await fetch(url);
		let data = await response.json();

		if (this.reportForm === 'aggregated') {
			this.aggregatedStats = data;
			console.log(this.aggregatedStats);
		} else {
			this.detailedStats = data;
		}

		this.queryInProgress = false;
	}
}));

Alpine.plugin(Tooltip);

Alpine.start();

const swiperSocialGallery = new Swiper('.swiper-social-gallery', {
	modules: [Navigation],
	slidesPerView: 'auto',
	// centeredSlides: true,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-social-gallery-next',
		prevEl: '.swiper-social-gallery-prev',
	},
});

const swiperGallery = new Swiper('.swiper-gallery', {
	modules: [Navigation],
	slidesPerView: 'auto',
	// centeredSlides: true,
	spaceBetween: 8,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-gallery-next',
		prevEl: '.swiper-gallery-prev',
	},
});

const swiperThumbnail = new Swiper('.swiper-thumbnail', {
	initialSlide: 0,
	slidesPerView: 3.5,
	// centeredSlides: true,
	// freeMode: true,
	watchSlidesProgress: true,
	cssMode: true,
	breakpoints: {
		1024: {
			slidesPerView: 6.5,
		}
	}
});

const swiperMagazine = new Swiper('.swiper-magazine', {
	modules: [Navigation, Pagination, Thumbs],
	initialSlide: 0,
	slidesPerView: 'auto',
	// centeredSlides: true,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-magazine-next',
		prevEl: '.swiper-magazine-prev',
	},
	pagination: {
		el: '.slider-magazine .swiper-pagination.magazine-pagination',
		type: 'fraction',
		formatFractionTotal: (number) => {
			return `${number} ` + (lang == "hu" ? "kép" : "photos");
		}
	},
	thumbs: {
		swiper: swiperThumbnail,
	},
	on: {
		slideChange: () => {
			window.dispatchEvent(new CustomEvent('slider.magazine.slidechange', { detail: this.activeIndex }));
		}
	}
});

const swiperTickets = new Swiper('.swiper-tickets', {
	modules: [Navigation],
	slidesPerView: 'auto',
	spaceBetween: 20,
	centeredSlides: true,
	// initialSlide: document.querySelector('.swiper-tickets') ? document.querySelector('.swiper-tickets').dataset.nextMatchIndex : 0,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-tickets-next',
		prevEl: '.swiper-tickets-prev',
	},
	on: {
		init: (swiper) => {
			if (document.querySelector('.swiper-tickets').dataset.nextMatchIndex) {
				swiper.slideTo(document.querySelector('.swiper-tickets').dataset.nextMatchIndex);
			}
		}
	}
});

const swiperPlayer = new Swiper('.swiper-player', {
	modules: [Navigation],
	slidesPerView: 'auto',
	// centeredSlides: true,
	slidesOffsetAfter: 16,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-player-next',
		prevEl: '.swiper-player-prev',
	},
});

const swiperVidiarena = new Swiper('.swiper-vidiarena', {
	modules: [Navigation],
	slidesPerView: 'auto',
	spaceBetween: 40,
	// centeredSlides: true,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-vidiarena-next',
		prevEl: '.swiper-vidiarena-prev',
	},
});

const swiperStats = new Swiper('.swiper-stats', {
	modules: [Pagination],
	slidesPerView: 'auto',
	spaceBetween: 40,
	centeredSlides: true,
	initialSlide: 2,
	cssMode: true,
	pagination: {
		el: '.swiper-stats-pagination',
		clickable: true
	}
});

const swiperPlayerSmall = new Swiper('.swiper-player-small', {
	modules: [Navigation],
	slidesPerView: 1,
	spaceBetween: 20,
	// centeredSlides: true,
	cssMode: true,
	navigation: {
		nextEl: '.swiper-player-next',
		prevEl: '.swiper-player-prev',
	},
	breakpoints: {
		768: {
			slidesPerView: 2
		},
		1024: {
			slidesPerView: 3
		},
	}
});

window.addEventListener('scroll', () => {
	const currentScroll = window.pageYOffset;
	if (currentScroll <= 0) {
		body.classList.remove(scrollUp);
		return;
	}

	if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
		// down
		body.classList.remove(scrollUp);
		body.classList.add(scrollDown);
	} else if (
		currentScroll < lastScroll &&
		body.classList.contains(scrollDown)
	) {
		// up
		body.classList.remove(scrollDown);
		body.classList.add(scrollUp);
	}
	lastScroll = currentScroll;
});

if(videos.length) {
	videos.forEach((item) => {
		const player = videojs(item);
		console.log(player);

		if (item.dataset.markers && item.dataset.markers.length) {
			player.markers({
				markers: item.dataset.markers
			});
		}
	});
}

const scene = document.getElementById('scene');
if (scene) {
	const parallaxInstance = new Parallax(scene);
}

// if (document.getElementById('datepicker')) {
// 	const datepicker = new easepick.create({
// 		element: document.getElementById('datepicker'),
// 		css: [
// 			'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
// 			'https://cdn.jsdelivr.net/npm/@easepick/amp-plugin@1.2.0/dist/index.css',
// 			'/assets/css/easepick.css',
// 		],
// 		zIndex: 10,
// 		lang: 'hu-HU',
// 		AmpPlugin: {
// 			dropdown: {
// 				months: true,
// 				years: true,
// 				minYear: 1901
// 			}
// 		},
// 		plugins: [AmpPlugin]
// 	});
// }

// if (document.getElementById('daterangepicker')) {
// 	const daterangepicker = new easepick.create({
// 		element: document.getElementById('daterangepicker'),
// 		css: [
// 			'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
// 			'https://cdn.jsdelivr.net/npm/@easepick/range-plugin@1.2.0/dist/index.css',
// 			'/assets/css/easepick.css',
// 		],
// 		zIndex: 10,
// 		lang: 'hu-HU',
// 		RangePlugin: {
// 			tooltip: false
// 		},
// 		plugins: [RangePlugin],
// 	});
// }
